import React from 'react';
import styled from 'styled-components';
// import moment from 'moment';
import { withRouter } from 'react-router-dom';

import {
  // ReactDateTimePicker,
  Input,
  Select,
} from '../../../../components/elements';
import DateFilter from '../DateFilter';

const Wrapper = styled.nav`
  padding: 1rem;
  border-bottom: 1px solid #f5f8fa;
  padding-bottom: 1rem;
`;

const filterOptions = [
  { value: 'FILTER BY DAY', label: 'FILTER BY DAY' },
  { value: 'FILTER BY MONTH', label: 'FILTER BY MONTH' },
  { value: 'FILTER BY WEEK', label: 'FILTER BY WEEK' },
];

const Search = ({
  dateFilterDisabled,
  handleChange,
  setStartDateRef,
  setEndDateRef,
  nameEnabled,
  refEnabled,
  bookingName,
  bookingReference,
}) => {
  const [filterBy, setFilterBy] = React.useState({
    value: 'FILTER BY DAY',
    label: 'FILTER BY DAY',
  });

  const [bookingNameRef, setBookingNameRef] = React.useState(null);
  const [bookingReferenceRef, setBookingReferenceRef] = React.useState(null);

  return (
    <Wrapper>
      <div className="columns">
        {dateFilterDisabled ? (
          <div className="column mt-5">
            <button
              type="button"
              className="button is-primary"
              onClick={() =>
                handleChange({
                  dateFilterDisabled: false,
                })
              }
            >
              Add Date Filter
            </button>
          </div>
        ) : (
          <>
            <div
              className="column"
              style={{ position: 'relative', top: '20px' }}
            >
              <Select
                options={filterOptions}
                value={filterBy}
                onChange={({ value }) => {
                  setFilterBy(filterOptions.find(ele => ele.value === value));
                }}
              />
            </div>
            <div
              className="column"
              style={{ position: 'relative', top: '20px' }}
            >
              <DateFilter
                filterType={filterBy}
                setStartDate={date => {
                  setStartDateRef(date);
                }}
                setEndDate={date => {
                  setEndDateRef(date);
                }}
              />
            </div>
            {!dateFilterDisabled && (
              <div className="column mt-5">
                <button
                  type="button"
                  className="button is-primary"
                  onClick={() => {
                    handleChange({
                      dateFilterDisabled: true,
                    });
                    setStartDateRef('');
                    setEndDateRef('');
                  }}
                >
                  Remove Filter
                </button>
              </div>
            )}
          </>
        )}
      </div>
      <div className="columns">
        <div style={{ width: '30%' }}>
          <div className="mr-1">
            <Input
              // label="Booking Name"
              type="text"
              id="booking_name"
              value={bookingNameRef ?? bookingName}
              onChange={e => {
                setBookingNameRef(e.target.value);
              }}
              placeholder="Enter a booking name to filter"
            />
          </div>
        </div>
        <div className="mr-1">
          <button
            type="button"
            className="button is-primary"
            onClick={async () => {
              handleChange({
                bookingName: bookingNameRef,
                nameEnabled: true,
              });
            }}
            disabled={bookingNameRef ? bookingNameRef?.length === 0 : true}
          >
            <span className="has-text-weight-semibold">
              Add Filter By Booking Name
            </span>
          </button>
        </div>
        {nameEnabled && (
          <a
            onClick={() => {
              handleChange({
                bookingName: '',
                nameEnabled: false,
              });
              setBookingNameRef(null);
            }}
            className="button is-grey"
          >
            <span className="has-text-weight-semibold">Remove Filter</span>
          </a>
        )}
      </div>
      <br />
      <div className="columns">
        <div style={{ width: '30%' }}>
          <div className="mr-1">
            <Input
              // label="Booking Name"
              type="text"
              id="booking_reference"
              value={bookingReferenceRef ?? bookingReference}
              onChange={e => {
                setBookingReferenceRef(e.target.value);
              }}
              placeholder="Enter a booking reference to filter"
            />
          </div>
        </div>
        <div className="mr-1">
          <button
            type="button"
            className="button is-primary"
            onClick={async () => {
              handleChange({
                bookingReference: bookingReferenceRef,
                refEnabled: true,
              });
            }}
            disabled={
              bookingReferenceRef ? bookingReferenceRef?.length === 0 : true
            }
          >
            <span className="has-text-weight-semibold">
              Add Filter By Booking Reference
            </span>
          </button>
        </div>
        {refEnabled && (
          <a
            onClick={() => {
              handleChange({
                bookingReference: '',
                refEnabled: false,
              });
              setBookingReferenceRef(null);
            }}
            className="button is-grey"
          >
            <span className="has-text-weight-semibold">Remove Filter</span>
          </a>
        )}
        <br />
      </div>
    </Wrapper>
  );
};

export default withRouter(Search);
